import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues } from 'redux-form';

import { Filter, Main } from 'Containers';
import SpecialMessageForm from './components/SpecialMessageForm';
import {
  clearReportDataAction,
  getSpecialMessageReportAction,
  getSpecialMessageReportExcel,
} from './state/actions';
import { FieldEnum, ReportFieldEnum } from 'Common/FieldEnum';
import { ReportGeneration } from 'Common/ObjectHelper';
import { SPECIAL_MESSAGE_FORM_NAME } from 'Common/FormEnum';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';

class SpecialMessageContainer extends Component {
  componentDidUpdate(prevProps) {
    const { report } = this.props;

    if (this.props.fetching && report) {
      if (report.length !== 0) {
        ReportGeneration(report, 'SpecialMessageReport');
        this.props.clearReportDataAction();
      }
    }
  }

  formSubmit = values => {
    const model = {
      SiteId: values[FieldEnum.SiteId],
      sortType: values[FieldEnum.SortBy],
      [ReportFieldEnum.ReportFormat]: values[ReportFieldEnum.ReportFormat],
    };


    if (values[ReportFieldEnum.ReportFormat] === reportFormatEnum.PDF) {
      this.props.getSpecialMessageReportAction(model);
    } else {
      this.props.getSpecialMessageReportExcel(model);
    }
  };

  getMainProps = () => {
    const { fetching } = this.props;

    return {
      toolbox: {
        formName: SPECIAL_MESSAGE_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          disabled: fetching,
          loading: fetching,
        },
        shown: true,
      },
    };
  };

  render() {
    const { formValues } = this.props;

    return (
      <Fragment>
        <Filter title={'Special Message'} />
        <Main {...this.getMainProps()}>
          <SpecialMessageForm
            formValues={formValues}
            initialValues={{
              [FieldEnum.SortBy]: '0',
              [ReportFieldEnum.ReportFormat]: reportFormatEnum.PDF,
            }}
            onSubmit={this.formSubmit}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { SpecialMessageState } = state;

  return {
    report: SpecialMessageState.report,
    fetching: SpecialMessageState.reportLoading,
    formValues: getFormValues(SPECIAL_MESSAGE_FORM_NAME)(state) || {},
  };
};

const mapDispatchToProps = {
  getSpecialMessageReportAction,
  clearReportDataAction,
  getSpecialMessageReportExcel,
};

export const SpecialMessage = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SpecialMessageContainer)
);



// WEBPACK FOOTER //
// ./src/pages/specialmessage/SpecialMessage.js